import { Controller, useFormContext } from "react-hook-form";
import Radio from "@/components/Radio/Radio";
import type { FormValues } from "../validation/schema";

const ATTENDANCE_OPTIONS = [
  {
    value: false,
    label: "None (Manual)",
    supportingText: undefined
  },
  {
    value: true,
    label: "Self Check-In",
    supportingText:
      "Allow participants to check-in via QR Code or name/ID form entry. Attendance can still be added manually as well."
  }
] as const;

export default function ModulesStep() {
  const { control } = useFormContext<FormValues>();

  return (
    <div className="flex flex-col gap-6">
      <p className="text-title-large">Setup additional modules that should be utilized for managing this activity.</p>

      <div>
        <p className="text-title-medium mb-4">Attendance Module</p>
        <Controller
          name="checkinEnabled"
          control={control}
          render={({ field }) => (
            <div className="flex flex-col gap-3">
              {ATTENDANCE_OPTIONS.map((option) => (
                <Radio
                  key={String(option.value)}
                  name="checkinEnabled"
                  label={option.label}
                  supportingText={option.supportingText}
                  checked={field.value === option.value}
                  onChange={() => field.onChange(option.value)}
                />
              ))}
            </div>
          )}
        />
      </div>
    </div>
  );
}
